module.exports = __webpack_public_path__ + "img/perdidaUbicacionGps.09aaf377.svg";